



































import { Component, Prop, Vue } from 'vue-property-decorator';
import { VueMultiselectOptions } from '@/models/select-dropdown';
import SelectDropdownField, {
  SelectDropdownFieldVariant
} from '@/componentsV2/molecules/SelectDropdownField/SelectDropdownField.vue';
import SearchService from '@/api/SearchService';
import SelectDropDownFieldUtils from '@/utils/selectDropdownFieldUtils';
import { ISearchResponse } from '@/models/general';

import SearhcBarItem from './SearchBarItem.vue';
import SearchBarEmptyState from './SearchBarEmptyState.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    SelectDropdownField,
    SearhcBarItem,
    SearchBarEmptyState
  }
})
export default class SearchBar extends Vue {
  @Prop({ default: false }) readonly error!: boolean;
  @Prop({ default: 'searchBar' }) readonly name!: string;
  @Prop({ default: 'searchBar' }) readonly translateKey!: string;
  @Prop({ default: 'normal' }) variant?: SelectDropdownFieldVariant;
  @Prop({ default: '' }) helpText?: string;
  @Prop({ default: true }) showHelpIcon?: boolean;

  isLoading = false;
  selected = null;
  options: Array<VueMultiselectOptions> = [];
  searchService: SearchService = new SearchService();

  textSearched = '';

  propertiesSelectdropdown = {
    ...SelectDropDownFieldUtils.getSelectdropdownPropertiesDefault(),
    name: this.name,
    translateKey: this.translateKey,
    useSearchIcon: true,
    maxlengthInput: '100'
  };

  getCountryCode() {
    return this.$store.getters['internationalization/getCountrySettings']
      .countryIso2;
  }

  async search(term: string) {
    this.textSearched = term;

    if (!term) return;

    this.isLoading = true;

    try {
      segmentIo.track('Search Log', { 'Search Term': term });

      const response = await this.searchService.search(term);

      this.options = response.data.items.map((result: ISearchResponse) => ({
        value: result.title,
        label: result.title,
        additionalInformation: result
      }));
    } finally {
      this.isLoading = false;
    }
  }

  triggerSelect(selectedOption: any) {
    this.$router.push(selectedOption.additionalInformation.path);
    this.selected = null;
  }

  triggerClearAll() {
    this.options = [];
    this.textSearched = '';
    this.$emit('triggerClearValue');
  }

  enterEvent() {
    this.$router.push(`/search-results?text=${this.textSearched}&page=1`);
    this.triggerClearAll();
  }
}
